module.exports = __webpack_public_path__ + "img/5-1.189ab8de.jpg";